module.exports = __webpack_public_path__ + "static/media/dolce&gabbana-the-one-big.9dc3e844.png";